import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { LocationsTurnsService } from 'src/app/services/turns-services/locations-turns-service/locations-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Location } from 'src/app/models/turns-models/location.model';

@Component({
  selector: 'app-turns-locations-breadcrumb-filter-card',
  templateUrl: './turns-locations-breadcrumb-filter-card.component.html',
  styleUrls: ['./turns-locations-breadcrumb-filter-card.component.scss']
})
export class TurnsLocationsBreadcrumbFilterCardComponent implements OnInit {

  @Input() locations;
  centers;
  statuses;
  centersForm = new FormGroup({});
  statusesForm = new FormGroup({});

  constructor(private locationsTurnsService: LocationsTurnsService,
    private userStorageService: UserStorageService) { }

  ngOnInit() {
    this.getCenters();
    this.getStatuses();
    if (this.userStorageService.getFilterLocations()) {
      this.centersForm.patchValue(this.userStorageService.getFilterLocations()['centersForm']);
      this.statusesForm.patchValue(this.userStorageService.getFilterLocations()['statusesForm']);
    }
    this.filter();
  }

  public updateCheckbox(form, reset?) {
    this._toggleCheckboxes(form, reset);
  }

  private _toggleCheckboxes(form, reset) {
    if (reset && form.get('all').value) {
      Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
    } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
      form.get('all').setValue(false);
    } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
      form.get('all').setValue(true);
    }
    this.userStorageService.setFilterLocations({ centersForm: this.centersForm.getRawValue(), statusesForm: this.statusesForm.getRawValue() });
    if (this.userStorageService.getFilterLocations()['centersForm']['all'] && this.userStorageService.getFilterLocations()['statusesForm']['all']) {
      this.userStorageService.deleteFilterLocations();
    }
    this.filter();
  }

  private getCenters() {
    const centers = new Array<string>();
    this.centersForm.addControl('all', new FormControl(true));
    this.locations.forEach((d: Location) => {
      if (centers.indexOf(d.CenterName) === -1) {
        centers.push(d.CenterName);
        this.centersForm.addControl(d.CenterName, new FormControl(false));
      }
    });
    this.centers = centers;
  }

  private getStatuses() {
    const statuses = new Array<string>();
    this.statusesForm.addControl('all', new FormControl(true));
    this.locations.forEach((d: Location) => {
      if (statuses.indexOf(d.Status) === -1) {
        statuses.push(d.Status);
        this.statusesForm.addControl(d.Status, new FormControl(false));
      }
    });
    this.statuses = statuses;
  }

  public filter() {
    const forms = {
      centersForm:
      {
        attribute: 'CenterName',
        values: []
      },
      statusesForm:
      {
        attribute: 'Status',
        values: []
      }
    };
    if (this.centersForm.get('all').value) {
      forms['centersForm'].values = Object.keys(this.centersForm.value).splice(1);
    } else {
      Object.entries(this.centersForm.value).forEach(c => { if (c[1]) { forms['centersForm'].values.push(c[0]); }});
    }
    if (this.statusesForm.get('all').value) {
      forms['statusesForm'].values = Object.keys(this.statusesForm.value).splice(1);
    } else {
      Object.entries(this.statusesForm.value).forEach(c => { if (c[1]) { forms['statusesForm'].values.push(c[0]); }});
    }
    this.locationsTurnsService.filterLocations(forms);
  }
}
